import React from 'react';
import {
  Route, Switch, withRouter,
  // Redirect,
} from 'react-router-dom';
import {
  Mobile, Otp, Success, Home, NotFound, FakeIndex,
  IdPassport, Scanning, TakePhoto, PersonalInformation,
  FatcaCRS, Preview, FormAgreements, Agreement, Checklist, Confirmation,
  QualifiedConfirmation, Payment, PaymentSuccess, PaymentFail,
} from 'pages';
// import { FormattedMessage } from 'react-intl';
import { PATH } from 'shared/constant';
import PrivateRoute from './PrivateRoute';

const Routes = ({ history }) => (
  <Switch>

    {/* <Route
      path={PATH.INDEX}
      exact
    >
      <Redirect to={PATH.LOGIN} />
    </Route> */}
    <Route
      path={PATH.INDEX}
      exact
      render={props => <FakeIndex {...props} />}
    />

    <Route
      path={PATH.LOGIN}
      search="?refCode=:id"
      render={props => (
        <Mobile
          navTitle="navbar.phoneNoVerification"
          // leftButton={<FormattedMessage id="navbar.signIn" />}
          {...props}
        />
      )}
    />
    <Route
      path={PATH.OTP}
      render={props => (
        <Otp
          navTitle="navbar.phoneNoVerification"
          // leftButton={<FormattedMessage id="navbar.signIn" />}
          {...props}
        />
      )}
    />
    <Route
      path={PATH.AUTH_SUCCESS}
      render={props => (
        <Success
          navTitle="navbar.phoneNoVerification"
          // leftButton={<FormattedMessage id="navbar.signIn" />}
          {...props}
        />
      )}
    />

    <PrivateRoute
      path={PATH.HOME}
      exact
      component={props => (<Home navTitle="navbar.home" isBlueNav {...props} />)}
    />
    <PrivateRoute
      path={PATH.ID_PASSPORT}
      component={props => <IdPassport navTitle="navbar.idPassport" {...props} onClose={() => history.push(PATH.HOME)} />}
    />
    <PrivateRoute
      path={PATH.ID_PASSPORT_SCANNING}
      component={props => <Scanning navTitle="navbar.idPassportScanning" {...props} onClose={() => history.push(PATH.HOME)} />}
    />
    <PrivateRoute
      path={PATH.TAKE_PHOTO}
      component={TakePhoto}
    />
    <PrivateRoute
      path={PATH.PERSONAL_INFORMATION}
      component={props => <PersonalInformation navTitle="navbar.personalInformation" {...props} onClose={() => history.push(PATH.HOME)} />}
    />
    <PrivateRoute
      path={PATH.FATCA_CRS}
      component={props => <FatcaCRS navTitle="navbar.fatcaCrsQuestionnaires" {...props} onClose={() => history.push(PATH.HOME)} />}
    />

    <PrivateRoute
      path={`${PATH.PREVIEW}/:id`}
      component={props => <Preview navTitle="navbar.previewAgreement" {...props} onClose={() => history.push(PATH.HOME)} />}
    />
    <PrivateRoute
      path={PATH.AGREEMENT}
      component={props => <Agreement navTitle="navbar.previewAgreement" {...props} onClose={() => history.push(PATH.HOME)} />}
    />
    <PrivateRoute
      path={PATH.FORM_AGREEMENTS}
      component={props => <FormAgreements navTitle="navbar.previewAgreement" {...props} onClose={() => history.push(PATH.HOME)} />}
    />

    <PrivateRoute
      path={PATH.PRINT_CHECKLIST}
      component={props => <Checklist navTitle="navbar.printChecklist" {...props} onClose={() => history.push(PATH.HOME)} />}
    />

    <PrivateRoute
      path={PATH.CONFIRMATION}
      component={props => <Confirmation navTitle="navbar.allDone" {...props} onClose={() => history.push(PATH.HOME)} />}
    />

    <PrivateRoute
      path={PATH.QUALIFIED_CONFIRMATION}
      component={props => <QualifiedConfirmation navTitle="navbar.qualifiedConfirmation" {...props} onClose={() => history.push(PATH.HOME)} />}
    />

    <PrivateRoute
      path={PATH.PAYMENT}
      component={props => <Payment navTitle="payment6.title" {...props} onClose={() => history.push(PATH.HOME)} />}
    />

    <PrivateRoute
      path={PATH.PAYMENT_SUCCESS}
      component={props => <PaymentSuccess navTitle="payment.transactionConfirmed" showStepper={false} {...props} onClose={() => history.push(PATH.HOME)} />}
    />

    <PrivateRoute
      path={PATH.PAYMENT_FAIL}
      component={props => <PaymentFail navTitle="payment.transactionFailed" showStepper={false} {...props} onClose={() => history.push('/payment')} />}
    />

    <Route
      component={NotFound}
    />
  </Switch>
);

export default withRouter(Routes);
